/**
 * Create Audit Form Page
 * Main form for creating new audits
 */

import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/$workspaceSlug/audits/new/")({
  component: RouteComponent,
  validateSearch: (search: Record<string, unknown>) => ({
    auditId:
      typeof search.auditId === "string" && search.auditId.trim().length > 0
        ? search.auditId
        : undefined,
  }),
});

function RouteComponent() {
  return <div>Coming soon...</div>;
}
